module.exports = __webpack_public_path__ + "static/media/moons_pago_amex.cc1978da.svg";